import { get } from 'lodash';

export const extractImages = (data, fieldConfig) => {
  return data.reduce((acc, item) => {
    // Extract images from all singleImageFields
    let allImages = [];
    
    fieldConfig.singleImageFields.forEach(field => {
      const image = get(item, field);
      if (image) {
        allImages.push(image);
      }
    });
    
    const id = item._id;
    
    // Map metadata for each image
    const imageData = allImages.map(image => {
      const metaData = {};
      
      // For each metadata field, get the value from the appropriate path
      Object.entries(fieldConfig.metadataFields).forEach(([key, path]) => {
        metaData[key] = get(item, path);
      });
      
      return {
        ...image,
        id,
        metaData
      };
    });
    
    return [...acc, ...imageData];
  }, []);
};